var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 4.29167C10.75 3.14271 9.74088 2.20833 8.5 2.20833C7.25912 2.20833 6.25 3.14271 6.25 4.29167C6.25 5.44063 7.25912 6.375 8.5 6.375C9.74088 6.375 10.75 5.44063 10.75 4.29167ZM13 4.29167C13 6.58958 10.9818 8.45833 8.5 8.45833C6.01825 8.45833 4 6.58958 4 4.29167C4 1.99375 6.01825 0.125 8.5 0.125C10.9818 0.125 13 1.99375 13 4.29167ZM0.625 17.8333C0.625 13.8125 4.15863 10.5417 8.5 10.5417C12.8414 10.5417 16.375 13.8125 16.375 17.8333C16.375 18.4083 15.8721 18.875 15.25 18.875C14.6279 18.875 14.125 18.4083 14.125 17.8333C14.125 14.9615 11.6016 12.625 8.5 12.625C5.39838 12.625 2.875 14.9615 2.875 17.8333C2.875 18.4083 2.37212 18.875 1.75 18.875C1.12788 18.875 0.625 18.4083 0.625 17.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5788302dada069828fc6855cd8fbb5b3.svg";
export { ForwardRef as ReactComponent };